import useTypedTranslation from '@hooks/useTypedTranslation'
import { formatObservationTime } from '@utils/dates'

import type { Shelf } from '@state/shelf/types'

/** Where a shelf's data comes from, counted from the selected day. Undefined without an observation. */
function useShelfSourceText(shelf: Shelf) {
  const { t, i18n } = useTypedTranslation()

  if (!shelf.source) return undefined

  const days = shelf.daysBeforeDay ?? 0

  let age = t('storeMap.shelf.source.daysBefore', { days })
  if (days === 0) age = t('storeMap.shelf.source.sameDay')
  if (days === 1) age = t('storeMap.shelf.source.oneDayBefore')

  return t('storeMap.shelf.source.line', {
    age,
    time: formatObservationTime(new Date(shelf.source.observedAt), i18n.language),
  })
}

export default useShelfSourceText
